"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _entrySourceStatsTable = _interopRequireDefault(require("./entry-source-stats-table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ByDivision extends _react.Component {
  render() {
    const statsByDivision = this.props.statsByYear.entrySource.reduce((divs, row) => {
      if (divs && divs[row.divisionSortOrder]) {
        divs[row.divisionSortOrder].totalCompeted += row.totalCompeted;
        divs[row.divisionSortOrder].competedAndEnteredOnline += row.competedAndEnteredOnline;
        divs[row.divisionSortOrder].competedAndPreEnteredByPost += row.competedAndPreEnteredByPost;
        divs[row.divisionSortOrder].enteredOnDay += row.totalCompeted - row.competedAndEnteredOnline - row.competedAndPreEnteredByPost;
        divs[row.divisionSortOrder].totalEntered += row.totalEntered;
        divs[row.divisionSortOrder].enteredOnlineAndNotInResults += row.enteredOnlineAndNotInResults;
        divs[row.divisionSortOrder].enteredByPostAndNotInResults += row.enteredByPostAndNotInResults;
        divs[row.divisionSortOrder].preEntered += row.totalEntered - row.enteredOnlineAndNotInResults - row.enteredByPostAndNotInResults;
      } else {
        divs[row.divisionSortOrder] = {
          statsID: row.divisionSortOrder,
          statsDescription: row.division,
          totalCompeted: row.totalCompeted,
          competedAndEnteredOnline: row.competedAndEnteredOnline,
          competedAndPreEnteredByPost: row.competedAndPreEnteredByPost,
          enteredOnDay: row.totalCompeted - row.competedAndEnteredOnline - row.competedAndPreEnteredByPost,
          totalEntered: row.totalEntered,
          enteredOnlineAndNotInResults: row.enteredOnlineAndNotInResults,
          enteredByPostAndNotInResults: row.enteredByPostAndNotInResults,
          preEntered: row.totalEntered - row.enteredOnlineAndNotInResults - row.enteredByPostAndNotInResults
        };
      }
      return divs;
    }, []).sort((a, b) => a.statsID > b.statsID);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card",
      style: {
        marginTop: 15
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("h3", null, " Entry Source Analysis By Division for ", this.props.statsByYear.id)), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_entrySourceStatsTable.default, {
      stats: statsByDivision
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = ByDivision;